import Api from '@/api'

const api = new Api()

export default {
  async fetchPermission({ commit }) {
    try {
      return await api.dashboard().fetch()
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
